import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import {
  Typography,
  Button,
  VaporIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Divider,
} from "@vapor/v3-components";
import { useTranslation } from "react-i18next";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";

interface PreviewDocumentProps {
  showPreview: boolean;
  typePreview: string;
  urlPreview: string;
  noDownloadVideo: boolean;
  closePreview: () => void;
}

export const PreviewDocument: React.FC<PreviewDocumentProps> = ({
  showPreview,
  typePreview,
  urlPreview,
  noDownloadVideo,
  closePreview,
}) => {
  const { t } = useTranslation();
  const renderContent = (type: string | null, urlFile: string) => {
    if (type && type.length > 0 && type?.substring(0, 1) !== ".")
      type = "." + type;
    switch (type?.toLowerCase()) {
      case ".pdf":
        return (
          <iframe
            src={urlFile}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="PDF Viewer"
          />
        );

      case ".mp4":
      case ".avi":
      case ".mkv":
      case ".mov":
      case ".wmv":
      case ".flv":
      case ".webm":
      case ".3gp":
      case ".ogg":
      case ".link":
        return (
          <video
            src={urlFile}
            muted // Rimuove l'audio per evitare interferenze
            loop
            controls
            controlsList={noDownloadVideo ? "nodownload" : ""}
            style={{ width: "100%", height: "100%" }}
          />
          //     <source src={urlFile} type="video/mp4" />
          //     Your browser does not support the video tag.
          //   </video>
        );

      case ".jpg":
      case ".png":
      case ".bmp":
      case ".gif":
        return (
          <img
            src={urlFile}
            alt="File Viewer"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        );

      case ".ppt":
      case ".pptx":
      case ".doc":
      case ".docx":
      case ".xls":
      case ".xlsx":
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              urlFile
            )}`}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Document Viewer"
          />
        );
      case ".html":
        return (
          <iframe
            src={urlFile}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="HTML Viewer"
          />
        );
      //   case ".link":
      //     return (
      //       <iframe
      //         src={urlFile}
      //         width="100%"
      //         height="100%"
      //         style={{ border: "none" }}
      //         title="HTML Viewer"
      //       />
      //     );
      case ".youtube":
        return (
          <iframe
            src={urlFile}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="HTML Viewer"
          />
        );

      default:
        return (
          <Typography variant="body1" color="text.secondary">
            File type not supported.
          </Typography>
        );
    }
  };

  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      fullScreen
      open={showPreview}
    >
      <DialogTitle>
        {/* <IconButton
                onClick={() => {
                  setShowPreview(false);
                }}
                edge="end"
                sx={{ marginRight: 2 }}
              >
                <VaporIcon icon={faArrowLeft} size="s" color="primary" />
              </IconButton>
              {t("doc-preview")} */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // Centrare verticalmente
          }}
        >
          <IconButton
            onClick={closePreview}
            edge="start" // Cambiato per allineare correttamente
            sx={{ marginRight: 2 }}
          >
            <VaporIcon icon={faArrowLeft} size="s" color="primary" />
          </IconButton>
          {t("doc-preview")}
        </Box>
      </DialogTitle>
      <Divider variant="fullWidth" />
      <DialogContent sx={{ p: 0 }}>
        <Box width="100%" height="100%">
          {renderContent(typePreview, urlPreview)}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          sx={{
            mr: 1,
          }}
          onClick={closePreview}
        >
          {t("close")}{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
